import PropTypes from 'prop-types';

const tabsOptionShape = PropTypes.shape({
  // Both of the fields below are read by Tabs.jsx only. DropdownAdapter, which replaces the tab
  // strip below the medium breakpoint once there are more than two options, maps options to
  // {label, value, selected} and drops them -- so neither reaches the mobile dropdown.

  // Overrides the tab's accessible name, for when the visible label is too terse on its own
  // ("Catalog Item" announcing as "Add a Catalog Item"). Omit it and the visible label is used.
  // Keep the visible label as a substring of it, or voice control stops matching what is read.
  ariaLabel: PropTypes.string,
  // Rendered as data-test-id on the tab, for QA page objects. The id attribute is not a
  // substitute: uniqueIdPrefix defaults to uniqueId('Tabs_') inside a defaultProps object
  // literal, which is evaluated once at module load -- so every Tabs instance in the app shares
  // one prefix and two on a page emit identical tab/panel ids.
  dataTestId: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  renderPanelBody: PropTypes.func.isRequired,
  url: PropTypes.string
});

export { tabsOptionShape };
